import { render, staticRenderFns } from "./VariableList.vue?vue&type=template&id=08b02c57&scoped=true&"
import script from "./VariableList.vue?vue&type=script&lang=js&"
export * from "./VariableList.vue?vue&type=script&lang=js&"
import style0 from "./VariableList.vue?vue&type=style&index=0&id=08b02c57&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b02c57",
  null
  
)

export default component.exports